var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow-x":"hidden"}},[_c('notifications',{attrs:{"position":"bottom left"}}),_c('LoginDialog'),_c('LoadingDialog'),_c('MessageDialog'),_c('div',{staticStyle:{"margin-top":"60px"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }